import classNames from 'classnames';

import styles from './Toast.module.scss';

type Props = {
  isOpen: boolean;
  message: string;
  className?: string;
};

const Toast = ({ isOpen, message, className }: Props) => {
  if (!isOpen) return null;

  return (
    <div className={classNames(styles.toast, className)} role="status" aria-live="polite">
      {message}
    </div>
  );
};

export default Toast;
